/*
Ashraf 10/03/2022 2699761741 fixed event tactic route issue
Sohel 10/12/2022 2699761741 Triggers Trigger Group Added breadcrumbs,label changes,pagination changes
Sohel 10/12/2022 2699761741 Triggers Added delete Functionality and Download Configuration Payload Changes
Sohel 10/15/2022 2699761741 Triggers Added Code Comments
Sohel 10/17/2022 2699761741 Trigger and Trigger Group fixed validation issue ,added tooltip and label changes
Akhila 10/18/2022 2699761741 search Triggers changed code filed to drop down and search triggers payload
Rohini 10/27/2022 2699761741 Added the classnames and modified styles for table
ashraf  10/28/2022  2699761741 fixed download configurations issue
Raghu 10/28/2022 2699761741 Table Icon Enhancements
Ashraf  10/03/2022 2699761741 fixed event tactic route issue
Sohel   10/12/2022 2699761741 Triggers Trigger Group Added breadcrumbs,label changes,pagination changes
Sohel   10/12/2022 2699761741 Triggers Added delete Functionality and Download Configuration Payload Changes
Sohel   10/15/2022 2699761741 Triggers Added Code Comments
Sohel   10/17/2022 2699761741 Trigger and Trigger Group fixed validation issue ,added tooltip and label changes
Akhila  10/18/2022 2699761741 search Triggers changed code filed to drop down and search triggers payload
Lalitha 10/27/2022 2699761741  download configuration  payload changes
Suresh Peddavoora 10/28/2022 2699761741  Added Rows per screen text in table pagination
Ashraf 10/29/2022 2699761741  Fixed add trigger issue
Ashraf 10/30/2022 2699761741  Fixed orderBy and orderDirection on download
Lalitha 10/31/2022 2699761741 Added clickable link functionality to trigger code
Prakash 10/31/2022 2699761741  Removed inline-styles for Pagination.
Lalitha 10/31/2022 2699761741 Removed unneccessary comments
lalitha 11/01/2022 2699761741 added span element in column link
Sohel 11/03/2022 2699761741 Added event Type in payload
saikrishna 11/03/2022 2699761741 changed the paginationOptions
Dilip 11/03/2022 2699761741 Added  code in delete popup
Sohel 11/05/2022 2699761741 run tooltip
Lalitha 11/08/2022 2699761741 Added Status column in table
Sohel 11/08/2022 2699761741 reset fetch data
Sohel 11/09/2022 2699761741 disabled run trigger
Sohel 11/14/2022 2699767208 implemented Copy Functionality
Sohel 11/14/2022 2700363416 implemented System notes functionality
Gummala Prakash 11/15/2022 2700363416 added className for add-trigger-table screen.
Sohel 11/15/2022 2700363416 fixed column alignment issue
akhila 11/18/2022 2699761741 search bugFix in Trigger code payload
Sohel 11/19/2022 2699761741 added userDefined notes popup
Suresh Peddavoora 12/01/2022 2699761741 Added ClassName for Draft Status and Removed Inline Styles
Sohel  12/05/2022 2699761741 Added Edit Icon and border to code
Akhila 12/08/2022 2699761741 added session storage for search items
lalitha 12/09/2022 2699761741 Added Created Date column and payload
kavyareddy 12/13/2022 2699761741 added created by and date in download configuration
Akhila 12/15/2022 2699761741 bug fix session search
Akhila 12/15/2022 2699761741 Added Role based access
Raghu 12/26/2022 2699761741 Added Dialog Component
sai krisha 30/12/2022 2699761741 add code description values
Dilip 01/05/2023 2699761741 removed mode column
Lalitha 01/10/2023 2699761741  fixed download configuration issue
Dilip 02/13/2023 2699761741 created by payload changes
sai krisha 02/13/2022 2699761741 added client code filed in search form
Guru Prasad 02/15/2022 2699761741 added tooltip for client code
Raghu 02/22/2023 2699761741 changed new UI buttons color
Suresh peddavoora 02/20/2023 2699761741 Payload changes in download
Dilip 02/22/2023 2699761741 added download usage configuration
Akhila 02/17/2023 2699761741 preview file implemented in download configuration
Suresh peddavoora 02/20/2023 2699761741 Payload changes in download
Ravi 02/22/2023 2699761741 Added Event in column
Ravi 02/22/2023 2699761741 Added Attached in Table column
Sohel 02/22/2023 2699761741 Added usage toast
Dilip 02/22/2023 2699761741 changed download usage configuration payload
Sohel 02/27/2023 2699761741 Fixed Sorting issue
Akhila 02/28/2023 2699761741 Added loader and download toast message in preview FIle
Dilip 02/28/2023 3031450488 payload change
Rohini 03/14/2023 3031450488  Added class name for table pagination
Suresh Peddavoora 03/15/2023 3031450488 Added Dropdown menu in Action Column in table
Suresh Peddavoora 03/16/2023 3031450488 Added test menu in Action Column in table
Raghu 04/04/2023 3031450488 added add icon
Guru Prasad 04/05/2023 3031450488 Fixed table alignments
Ravi 04/13/2023 3031450488 Added event type in search
Ravi 05/31/2023 3031450488 changed delete popup message
Akhila 06/07/2023 3031450488 added breadcrum code and description
Akhila 06/08/2023 3031450488 created date change to date created field and column
uday 16/10/2023 3031450488 add scroll for table
*/

import React, {createRef, useEffect, useState, useRef} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination, Tooltip} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {httpPaginationDelete, httpPaginationPost} from '../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import {
  fetchTriggerUsage,
  printEventTactics,
  ResetMessage as resetMessage,
  ResetStatus as resetStatus,
  resetTriggerUsage,
} from '../../../../redux/reducers/EventTactics/EventTactics';
// import FileCopyIcon from "@material-ui/icons/FileCopy";
import {
  SuccessSnackbar,
  ErrorSnackbar,
  WarningSnackbar,
} from '../../../../components/CustomSnackBar';
import PageLoader from '../../../../components/PageLoader';
import DeleteTableRecordPopup from './../../../../util/DeleteTableRecordPopup';
import {useUpdateEffect} from 'react-use';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {makeStyles} from '@material-ui/core';
import {tablePageRows} from '../../../../constants/ReusableConstants';
import CopyReport from './CopyReport';
import DialogBox from './../../../../components/DialogBox/index';
import {
  resetCopyReport,
  fetchEventTactic,
  resetConfigUrl,
  resetDockey,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import TriggerNote from './TriggerNote';
import {resetPostStatus} from '../../../../redux/reducers/EventTactics/AddNote';
import moment from 'moment';
import {fetchCreatedByDropDownData} from '../../../../redux/reducers/ReportMaster';
import UsageMessage from '../../../../util/UsageMessage';
import OverrideRule from '../../../../components/OverrideRule';
import {postPrintUsage, resetPrintUsageData} from '../../../../redux/reducers/printUsage';
import {downloadButton} from '../../../../util/Content';
import PreviewFileDialog from '../../../../util/PreviewFileDialog';
import axios from 'axios';
import {resetDownloadMsg} from '../../../../redux/reducers/PreviewFileData';

import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../util/ActionMenuItem';
import {MTableToolbar} from 'material-table';
import AddIcon from '@material-ui/icons/AddOutlined';
export default function EventTacticSearchTable({
  setValue,
  searchData,
  setEventTacticCode,
  submit,
  setSubmit,
  setRunClicked,
  setRowDataCode,
  setIsCopyIcon,
  isCopyIcon,
  setRowSelected,
  setTriggerMaintenanceData = () => {},
}) {
  const columns = [
    {
      title: 'Trigger Name',
      field: 'code',
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            dispatch(fetchEventTactic(rowData.id));
            setValue(1);
            setEventTacticCode(rowData.code);
            setRowSelected(rowData.id);
          }}
        >
          {rowData?.code ? rowData.code.replace(/ /g, '\u00a0') : ""}
        </span>
      ),
    },
    {
      title: 'Trigger Description',
      field: 'description',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData.description ? rowData.description.replace(/ /g, '\u00a0') : ""}
          </div>
        </>
      ),
    },
    {
      title: 'Event',
      field: 'event',
    },
    {
      title: 'Client Code ',
      field: 'clientCode',
      cellStyle: {
        maxWidth: 150,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.clientCode?.split(',').join(', ')}>
            <span>{rowData?.clientCode?.split(',').join(', ')}</span>
          </Tooltip>
        );
      },
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Attached',
      field: 'isUsed',
      render: (rowData) => (rowData?.isUsed === 'Y' ? 'Yes' : 'No'),
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="draft-status status">
            <span>Draft</span>
          </div>
        ) : (
          <div className="completed-status status">
            <span>Completed</span>
          </div>
        ),
    },
  ];
  const useStyles = makeStyles((theme) => ({
    'link': {
      color: '#320469 !important',
      borderBottom: '1px solid #000099',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();
  const [countTotal, setCountTotal] = useState('');
  const tableRef = createRef();
  const dispatch = useDispatch();
  const {
    copySuccessMsg,
    copyErrorMsg,
    copyReportStatus,
    copyCode,
    downloadSuccessMsg,
    configurationUrl,
    dockey,
    triggerUsageData,
  } = useSelector(({addEventTactic}) => addEventTactic);
  const {systemerrorMsg, systemsuccessMsg} = useSelector(({addNoteEvent}) => addNoteEvent);
  const [arrayLast, setArrayLast] = useState(false);
  const queryRef = useRef(null);
  const [rows, setRows] = useState(defaultRows);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [tstmsg, setToastMsg] = useState('');
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [printSearch, setPrintSearch] = useState('');
  const [status, setStatus] = useState(false);
  const [copyTrigger, setCopyTrigger] = useState(false);
  const [oldTriggerCode, setOldTriggerCode] = useState('');
  const [codeAndDescription, setCodeAndDescription] = useState({});
  const [triggerData, setTriggerData] = useState();
  const [isUsage, setIsUsage] = useState(false);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const [customError, setCustomError] = useState(false);
  const roleDataDisable = roleData?.window?.['Triggers Maintenance']?.TM;
  const [isNote, setIsNote] = useState(false);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);

  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  const [loading, setIsLoadingDelete] = useState(false);
  // handle Delete Trigger(2699761741)
  // const handleDelete = (rowData) => {

  // };

  const handleEdit = (rowData) => {
    dispatch(fetchEventTactic(rowData.id));
    setValue(1);
    setEventTacticCode(rowData.code);
    setRowSelected(rowData.id);
  };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setTriggerData(rowData);
  };
  const handleCopy = (rowData) => {
    setOldTriggerCode(rowData?.code);
    setCodeAndDescription(rowData);
    setCopyTrigger(true);
  };
  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    setTriggerMaintenanceData(rowData);
    dispatch(fetchTriggerUsage(rowData?.id));
  };
  // closed delete popup(2699761741)
  const handleClose = () => {
    setIsDelete(false);
    setUserMetrixDelete(false);
  };

  // Delete Trigger(2699761741)
  const handleSubmit = () => {
    httpPaginationDelete(`event/delete/trigger/${deleteData?.id}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingDelete(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingDelete(false);
      }
      readData();
    }
  }, [configurationUrl]);

  // reset Toast message(2699761741)
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  // based submit update table(2699761741)
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  const {successMsg, errorMsg, isLoading, eventTacticsPrintStatus} = useSelector(
    ({addEventTactic}) => addEventTactic,
  );

  // Print Trigger(2699761741)
  useEffect(() => {
    if (eventTacticsPrintStatus && eventTacticsPrintStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [eventTacticsPrintStatus]);
  useEffect(() => {
    if (copyReportStatus === 200) {
      setTimeout(() => {
        dispatch(fetchEventTactic(copyCode));
        dispatch(resetCopyReport());
        setValue(1);
        setCopyTrigger(false);
      }, 2500);
    }
  }, [copyReportStatus]);
  useEffect(() => {
    if (copyErrorMsg || copySuccessMsg) {
      setTimeout(() => {
        dispatch(resetCopyReport());
      }, 2500);
    }
  }, [copyErrorMsg, copySuccessMsg]);
  useEffect(() => {
    if (systemerrorMsg || systemsuccessMsg) {
      dispatch(resetPostStatus());
    }
  }, [systemerrorMsg, systemsuccessMsg]);
  // based on status rerender table(2699761741)
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedByDropDownData('triggermaintaince'));
      setStatus(false);
    }
  }, [status]);
  const handleDelete = (rowData) => {
    dispatch(fetchTriggerUsage(rowData?.id));
    setDeleteData(rowData);
    setIsDelete(false);
    setDeleteUsage(true);
  };
  useEffect(() => {
    if (triggerUsageData?.userMetrix === 'No') {
      deleteUsage ? setUserMetrixDelete(false) : setCustomError(true);
      deleteUsage && setIsDelete(true);
      setTimeout(() => {
        setCustomError(false);
        dispatch(resetTriggerUsage());
      }, 3000);
    } else if (triggerUsageData?.userMetrix === 'Yes') {
      if (deleteUsage) {
        setIsDelete(true);
        setUserMetrixDelete(true);
      } else {
        setValue(2);
      }
    }
  }, [triggerUsageData]);
  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      setIsUsage(true);
      setIsDelete(false);
      setUserMetrixDelete(false);
    } else {
      handleSubmit();
    }
  };
  useEffect(() => {
    customError && setCustomError(false);
    setValue(0);
    isDelete && setIsDelete(false);
  }, []);
  useEffect(() => {
    dispatch(resetStatus());
    // setCopy(null);
  }, []);
  const handleCopyTrigger = () => {
    setCopyTrigger(false);
  };
  const handleCloseDialog = () => {
    setIsNote(false);
  };
  const searchsessionTrigger = JSON.parse(sessionStorage.getItem('searchTrigger'));
  if (searchsessionTrigger && !submit) {
    searchData = searchsessionTrigger;
  }
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Trigger"
        value={
          userMetrixDelete ? (
            <UsageMessage value={'Trigger'} />
          ) : (
            `Are you sure you want to delete the ${deleteData?.code} Trigger ?`
          )
        }
        buttonCondition={userMetrixDelete}
        handleSubmit={handleDeleteUsage}
      />
      <OverrideRule
        dialogTitle="Delete Trigger"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title={`${deleteData?.code || ''} - ${
          deleteData?.description || ''
        } Trigger has been used in the following Exports.`}
        data={triggerUsageData?.placeResponse}
        isOverRide={false}
      />
      <DialogBox
        open={copyTrigger}
        dialogClose={handleCopyTrigger}
        title="Copy Trigger "
        maxWidth="md"
        hideFooter={true}
      >
        <CopyReport oldTriggerCode={oldTriggerCode} codeAndDescription={codeAndDescription} />
      </DialogBox>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Trigger Maintenance'}
      />
      <DialogBox open={isNote} dialogClose={handleCloseDialog} title="Trigger Notes" maxWidth="lg">
        <TriggerNote triggerData={triggerData} />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields actions-dropdown-table tablescroll-block">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `event/search/all`;
                // search triggers payload change(2699761741)
                const bodyObj = {
                  code: searchData?.code ? searchData?.code : '',
                  description: searchData?.description ? searchData?.description : '',
                  eventType: searchData?.event?.valueCode ? searchData?.event?.valueCode : '',
                  mode: searchData?.mode ? searchData?.mode?.value : '',
                  limit: query.pageSize ? query.pageSize : null,
                  isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  search: query?.search ? query?.search : '',
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  clientCode: searchData?.clientCode?.clientNumber ?
                    searchData?.clientCode?.clientNumber :
                    '',
                };
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                queryRef.current = query;
                setPrintSearch(query?.search?.trim());
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      setSubmit(false);
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setCountTotal(response.data.response.count);
                        setArrayLast(data.length === 1);
                        setEventTacticCode('');
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              toolbarButtonAlignment: 'left',
              search: false,
              pageSize: rows,
              toolbar: true,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            // actions={[
            //   // (rowData) => ({
            //   //   icon: () => <PlayCircleOutlineIcon />,
            //   //   tooltip: rowData?.isDraft !== "Y" ? "Run" : "",
            //   //   disabled:rowData?.isDraft === "Y",
            //   //   onClick: (event, rowData) => {
            //   //     setRunClicked(true);
            //   //     setRowDataCode(rowData?.code);
            //   //   },
            //   // }),
            //   {
            //     icon: () => <EditOutlinedIcon />,
            //     tooltip: "Edit",
            //     disabled: roleDataDisable?.edit === false,
            //     onClick: (event, rowData) => {
            //       dispatch(fetchEventTactic(rowData.id));
            //       setValue(1);
            //       setEventTacticCode(rowData.code);
            //       setRowSelected(rowData.id);
            //     },
            //   },
            //   (rowData) => ({
            //     icon: () => <FileCopyOutlinedIcon />,
            //     tooltip: "Copy",
            //     disabled: roleDataDisable?.add === false,
            //     onClick: (event, rowData) => {
            //       //setCopy(rowData.reportId);
            //       setCopyTrigger(true);
            //       setOldTriggerCode(rowData?.code);
            //       setCodeAndDescription(rowData);
            //     },
            //   }),
            //   {
            //     icon: () => (
            //       <>
            //         <Button
            //           type="button"
            //           variant="outlined"
            //           className={`search-btn`}
            //           disabled={roleDataDisable?.add === false}
            //           onClick={() => setValue(1)}
            //         >
            //           Add Trigger
            //         </Button>
            //       </>
            //     ),
            //     isFreeAction: true,
            //     disabled: roleDataDisable?.add === false,
            //     onClick: (event) => {
            //       setValue(1);
            //     },
            //   },
            //   // may require
            //   // (rowData) => ({
            //   //   icon: () => <GetAppIcon />,
            //   //   tooltip: "Download Report",
            //   // }),
            //   (rowData) => {
            //     return {
            //       icon: () => <DeleteOutlineOutlinedIcon className={classes.copyButtonroot} />,
            //       tooltip: "Delete",
            //       disabled: roleDataDisable?.delete === false,
            //       onClick: () => {
            //         handleDelete(rowData);
            //       },
            //     };
            //   },
            //   {
            //     icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //     tooltip: "Trigger Notes",
            //     onClick: (event, rowData) => {
            //       setIsNote(true);
            //       setTriggerData(rowData?.code);
            //     },
            //   },
            // ]}
            // may require
            // editable={{
            //   onRowDelete: (rowData) =>
            //     new Promise((resolve, reject) => {
            //       httpPaginationDelete(`rules/delete/rulegroup/${rowData.groupId}`).then(
            //         (response) => {
            //           if (response?.status === 200) {
            //             resolve();
            //             dispatch(fetchSuccess(response));
            //             setTimeout(() => {
            //               dispatch(resetMessage());
            //             }, 6000);
            //           } else {
            //             reject();
            //             dispatch(fetchError(response));
            //             setTimeout(() => {
            //               dispatch(resetMessage());
            //             }, 6000);
            //           }
            //         }
            //       );
            //     }),
            // }}

            actions={[
              {
                icon: () => <SaveIcon />,
                tooltip: 'Save User',
                onClick: (event, rowData) => console.log(rowData, 'rowData'),
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer pagination-block">
                  <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      disabled={Boolean(countTotal === 0)}
                      onClick={(event) => {
                        dispatch(
                          postPrintUsage({
                            baseCategory: '',
                            code: searchData?.code ? searchData.code : '',
                            description: searchData?.description ? searchData?.description : '',
                            displayName: '',
                            fileType: '',
                            recordFormatType: '',
                            returnType: '',
                            sourceType: 'TRIGGER MAINTENANCE',
                            isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                            search: '',
                            frameworkUsageOrderBy: '',
                            frameworkUsageOrderDerection: '',
                            fieldListOrderBy:
                              queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                queryRef.current.orderBy.field :
                                '',
                            fieldListOrderDerection: queryRef.current?.orderDirection ?
                              queryRef.current?.orderDirection :
                              '',
                            category: '',
                            fieldName: '',
                            repositoryDescription: '',
                            repositoryName: '',
                            repositoryType: '',
                            createdBy: searchData?.createdBy?.userLoginName ?
                              searchData?.createdBy?.userLoginName :
                              '',
                            createdDate: searchData?.createdDate ?
                              moment(searchData?.createdDate).format('MM/DD/YYYY') :
                              '',
                          }),
                        );
                      }}
                    >
                      Download Configuration Usage
                    </Button>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                      color="primary"
                      disabled={!countTotal}
                      onClick={(event) => {
                        dispatch(
                          printEventTactics({
                            eventTacticCode: searchData?.code ? searchData.code : '',
                            eventTacticDescription: searchData?.description ?
                              searchData?.description :
                              '',
                            eventType: '',
                            eventTacticMode: searchData?.mode ? searchData?.mode.value : '',
                            isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                            createdBy: searchData?.createdBy?.userLoginName ?
                              searchData?.createdBy?.userLoginName :
                              '',
                            createdDate: searchData?.createdDate ?
                              moment(searchData?.createdDate).format('MM/DD/YYYY') :
                              '',
                            search: printSearch ? printSearch : '',
                            orderBy:
                              queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                queryRef.current.orderBy.field :
                                '',
                            orderDirection: queryRef.current?.orderDirection ?
                              queryRef.current?.orderDirection :
                              '',
                            clientCode: searchData?.clientCode?.clientNumber ?
                              searchData.clientCode?.clientNumber :
                              '',
                          }),
                        );
                      }}
                    >
                      {downloadButton}
                    </Button>
                  </div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleUsage={handleUsage}
                  handleCopy={handleCopy}
                  hiddenMenu={{
                    edit: false,
                    copy: false,
                    notes: false,
                    hiddenDelete: false,
                    execution: true,
                    run: true,
                    usage: false,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: roleDataDisable?.edit === false,
                    disableRun: false,
                    disableCopy: roleDataDisable?.add === false,
                    disableDelete: roleDataDisable?.delete === false,
                    disableUsage: false,
                    disableExecution: false,
                    disableNotes: false,
                    disableUser: false,
                    disablePassword: false,
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {
                      <Button
                        type="button"
                        variant="outlisetOpenned"
                        className={`mx-1 search-btn`}
                        disabled={roleDataDisable?.add === false}
                        isFreeAction={true}
                        onClick={() => {
                          setValue(1);
                        }}
                        startIcon={<AddIcon />}
                      >
                        Add Trigger
                      </Button>
                    }
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </Grid>
      {isLoading || loading || printUsageIsLoading ? <PageLoader /> : ''}
      {(errorMsg || deleteErrorMsg || copyErrorMsg || systemerrorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar
          errorMsg={
            errorMsg || deleteErrorMsg || copyErrorMsg || systemerrorMsg || printUsageErrorMsg
          }
        />
      )}
      {(successMsg ||
        tstmsg ||
        copySuccessMsg ||
        systemsuccessMsg ||
        downloadSuccessMsg ||
        printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={
            successMsg ||
            tstmsg ||
            copySuccessMsg ||
            systemsuccessMsg ||
            downloadSuccessMsg ||
            printUsageSuccessMsg
          }
        />
      )}
      {customError && <WarningSnackbar errorMsg={`This Trigger is not being used anywhere`} />}
    </>
  );
}
